import {NgModule} from '@angular/core';
import {ResourcesComponent} from './components/resources.component';
import {ResourcesContainerComponent} from './containers/resources-container.component';
import {CommonModule} from '@angular/common';
import {SwiperModule} from 'angular2-useful-swiper';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {
  DateAdapter, MAT_DATE_FORMATS,
  MatButtonModule,
  MatDatepickerModule,
  MatDialogModule, MatIconModule,
  MatInputModule, MatNativeDateModule,
  MatProgressSpinnerModule,
  MatSelectModule
} from '@angular/material';
import {DxCheckBoxModule, DxDataGridModule, DxSelectBoxModule} from 'devextreme-angular';
import {ProductCategoryService} from '../product-category/services/product-category.service';
import {OrderByPipe} from '../pipes/orderby.pipe';
import {MomentDateAdapter} from '../date-adapter/moment-date-adapter.class';
import {MOMENT_DATE_FORMATS} from '../date-formats/moment-date-formats';
import {CategoryComponent} from './components/category/category.component';
import {CategorySelectionContainerComponent} from './components/category-selection/category-selection.container.component';
import {ProductSelectComponent} from './components/product-select.component';


@NgModule({
  imports: [
    CommonModule,
    SwiperModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatDialogModule,
    MatIconModule,
    DxDataGridModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    MatNativeDateModule,
    NgbModule
  ],
  declarations: [
    ResourcesContainerComponent,
    ResourcesComponent,
    CategoryComponent,
    CategorySelectionContainerComponent,
    ProductSelectComponent
  ],
  providers: [ProductCategoryService, HttpClientModule, OrderByPipe,
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS }]
})
export class ResourcesModule {}



// WEBPACK FOOTER //
// ./src/app/resources/resources.module.ts